import styled, { css } from "styled-components";

import type { ModalProps } from "@braze/beacon-core";
import { getSpacing } from "@braze/beacon-styling";

const operatorButtonSizePx = 32;
const modalCloseIconSizePx = 24;

// Operator button is 32px; modal close icon is 24px. Shift up by half the difference to vertically center them.
const operatorButtonTopOffsetPx = (operatorButtonSizePx - modalCloseIconSizePx) / 2;

const largeModalOperatorButtonOffset = css`
  top: calc(${getSpacing("xl")} - ${operatorButtonTopOffsetPx}px);
  right: calc(${getSpacing("xl")} + ${modalCloseIconSizePx}px + ${getSpacing("md")});
`;

const smallModalOperatorButtonOffset = css`
  top: calc(${getSpacing("lg")} - ${operatorButtonTopOffsetPx}px);
  right: calc(${getSpacing("lg")} + ${modalCloseIconSizePx}px + ${getSpacing("md")});
`;

export const StyledOperatorLaunchButtonWrapper = styled.div<{ $size?: ModalProps["size"] }>`
  position: absolute;

  ${({ $size }) =>
    $size === "md" || $size === "lg" || $size === "xl"
      ? largeModalOperatorButtonOffset
      : smallModalOperatorButtonOffset}

  & .db-braze-operator-launch-button {
    width: ${operatorButtonSizePx}px;
    height: ${operatorButtonSizePx}px;
  }
`;
